import Axios from 'axios'
import { message } from 'antd'

const successCode = ['200', 200, 0, '0', 'ok', 'true']

// 请求失败后的错误统一处理
const netErrorHandle = (status: any, msg: any) => {
  switch (status) {
    case 401:
      window.location.href = '/'
      break
    default:
      if (msg) {
        message.error(msg)
      } else {
        message.error(`服务器异常: ${status}`)
      }
  }
}

// 处理登录态失效
let timer:any
const handleNoLogin = (res:any) => {
  if (res.data.status === 'error' && res.data.code === '401') {
    // 由于多个接口返回登陆失效，采用节流处理
    if (!timer) {
      timer = setTimeout(() => {
        message.error('登录失效，请重新登录')
        window.location.href = '/'
      }, 100)
    }
  }
}

// 创建axios实例
const instance = Axios.create({ timeout: 5000 })

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  (config) => {
    config.withCredentials = true
    config.headers = {
      'X-Requested-With': 'XMLHttpRequest'
    }
    return config
  },
  (error) => Promise.reject(error)
)

/**
 * 响应拦截器
 * 拦截响应并统一处理
 */

instance.interceptors.response.use(
  (res: any) => {
    handleNoLogin(res)
    if (res.status && res.status === 200 && (successCode.indexOf(res.data.status) > -1 || successCode.indexOf(res.data.code) > -1)) {
      return Promise.resolve(res.data)
    } else {
      return Promise.reject(res)
    }
  },
  (error) => {
    const { response, message: msg } = error
    if (response) {
      console.warn(response)
      netErrorHandle(response.status, response.data.message)
      return Promise.reject(response)
    } else {
      console.warn(msg)
      if (msg && msg.indexOf('timeout') > -1) {
        message.error('请求超时，请稍后重试')
        return Promise.reject(error)
      } else if (!window.navigator.onLine) {
        // 通知断网
        message.error('请求失败，请检查您的网络连接情况')
        return Promise.reject(error)
      } else {
        return Promise.reject(error)
      }
    }
  }
)

export default instance
